export const DRIVER_BATA = 400;
export const MIN_ONEWAY_KM = 130;

export const VEHICLES = [
  {
    type: 'Sedan',
    image: '/images/car-detail/sedan.png',
    fleetImage: '/images/vehicles/sedan.png',
    rate: 15,
    seats: '4 Seats',
    description: 'Premium comfort travel',
    features: ['AC', 'Power Steering', 'Navigation'],
  },
  {
    type: 'SUV',
    image: '/images/car-detail/suv.png',
    fleetImage: '/images/vehicles/suv.png',
    rate: 20,
    seats: '5 Seats',
    description: 'Spacious & luxury travel',
    features: ['AC', 'Power Steering', 'Entertainment'],
  },
  {
    type: 'MUV',
    image: '/images/car-detail/suv.png',
    fleetImage: '/images/vehicles/suv.png',
    rate: 22,
    seats: '6 Seats',
    description: 'Ideal for group travel',
    features: ['AC', 'Power Steering', 'Entertainment'],
  },
];

/** Customer-facing name. Internal id stays MUV so bookings stay compatible. */
export const getVehicleDisplayName = (typeOrVehicle) => {
  const type = typeof typeOrVehicle === 'string' ? typeOrVehicle : typeOrVehicle?.type;
  const key = String(type || '').trim().toLowerCase();
  if (key === 'muv' || key === 'crysta') return 'Crysta';
  return type || '';
};

export const getBillingDistance = (actualDistance, tripType) => {
  const actual = actualDistance || 0;
  const oneway = Math.max(actual, MIN_ONEWAY_KM);
  if (tripType === 'Round Trip') return oneway * 2;
  return oneway;
};

export const getVehiclePrice = (actualDistance, rate, tripType = 'One Way') => {
  return Math.round(getBillingDistance(actualDistance, tripType) * rate + DRIVER_BATA);
};
